export default {
    ALTA_MEDICA: 1,
    EVASAO: 2,
    ENCAMINHAMENTO_HOSPITALAR: 3,
    AGUARDANDO_VAGA_HOSPITALAR: 4,
    OBITO: 5,
    PACIENTE_LIBERADO: 6,
    FAA_EXTRAVIADA: 7
}